const isArray = a => Array.isArray(a);

const isObject = o =>
  o === Object(o) &&
  !isArray(o) &&
  typeof o !== "function" &&
  !(o instanceof Date);

const snakeCase = str =>
  str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

const isDateString = str => {
  // This is a simple check to identify if the string is a date
  return !isNaN(Date.parse(str));
};

const camelToSnake = o => {
  if (isObject(o)) {
    const n = {};
    Object.keys(o).forEach(k => {
      n[snakeCase(k)] = camelToSnake(o[k]);
    });

    return n;
  }
  if (isArray(o)) {
    return o.map(i => camelToSnake(i));
  }
  if (o instanceof Date) {
    return o;
  }

  return o;
};

export { camelToSnake, snakeCase };
